var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBasketcomponent = function SvgBasketcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.333 7.667v1.666H9l3 6.325-1.125 2.034c-.608 1.116.192 2.475 1.458 2.475h10V18.5h-10l.917-1.667h6.208c.625 0 1.175-.341 1.459-.858l2.983-5.408a.83.83 0 0 0-.725-1.234H10.842l-.784-1.666H7.333Zm5 13.333c-.916 0-1.658.75-1.658 1.667 0 .916.742 1.666 1.658 1.666.917 0 1.667-.75 1.667-1.666C14 21.75 13.25 21 12.333 21Zm6.675 1.667c0-.917.742-1.667 1.659-1.667.916 0 1.666.75 1.666 1.667 0 .916-.75 1.666-1.666 1.666-.917 0-1.659-.75-1.659-1.666Z",
    fill: "current"
  })));
};
export default SvgBasketcomponent;